import React from 'react';

const Loader: React.FC = () => (
  <div className="flex justify-center items-center py-8">
    <div className="w-8 h-8 border-2 border-[rgba(146,222,113,0.2)] border-t-accent rounded-full animate-spin" />
  </div>
);

export default Loader;
